import i18n from "@/i18n";
import { ensureGlobals } from "@/i18n/load";

export async function i18nGuard(to) {
  const supported = ["en", "cy"];
  const locale = supported.includes(to.params?.locale)
    ? to.params.locale
    : "en";

  i18n.global.locale.value = locale;
  document.documentElement.lang = locale;
  document.documentElement.dir = "ltr";

  await ensureGlobals(locale);
}
